module.exports = __webpack_public_path__ + "0f679484aa61c0165abce53e135c2b4e.jpg";